export default __webpack_public_path__ + "images/0x0cae51e1032e8461f4806e26332c030e34de3adb.png";